import React, { useEffect, useState } from "react";
import { Alert } from "@amzn/awsui-components-react";

const staleAfterMs = 36 * 60 * 60 * 1000;

export default function OMSReportFreshness({
  sourceRefreshedAt,
}: {
  sourceRefreshedAt: string;
}) {
  const deadline = new Date(sourceRefreshedAt).getTime() + staleAfterMs;
  const [stale, setStale] = useState(() => Date.now() >= deadline);
  useEffect(() => {
    let timer: number | undefined;
    function checkFreshness() {
      window.clearTimeout(timer);
      const remaining = deadline - Date.now();
      setStale(remaining <= 0);
      if (Number.isFinite(remaining) && remaining > 0) {
        timer = window.setTimeout(
          checkFreshness,
          Math.min(remaining, 2147483647)
        );
      }
    }
    checkFreshness();
    window.addEventListener("focus", checkFreshness);
    document.addEventListener("visibilitychange", checkFreshness);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener("focus", checkFreshness);
      document.removeEventListener("visibilitychange", checkFreshness);
    };
  }, [deadline]);
  return stale ? (
    <Alert type="warning" header="Report is older than expected">
      You can still export this report.
    </Alert>
  ) : null;
}
